// extracted by mini-css-extract-plugin
export var carouselHeroStyling = "HeroCarousel-module--carouselHeroStyling--508c4";